import Sequences from 'defs/sequences';
import { SequenceStates } from 'defs/sequences/utils';
import { SequencesActionType } from './sequences.actionCreators';
import { FINISH_SEQUENCE, FLUSH_SEQUENCE, START_SEQUENCE } from './sequences.actionTypes';

export type SequencesStateType = {
	[key: string]: string;
};

export type RootStateType = {
	sequences?: SequencesStateType;
};

export const initialState: SequencesStateType = (() => {
	const initialInternalState = {};
	const sequenceKeys = Object.keys(Sequences);

	sequenceKeys.forEach((sequenceKey: string) => {
		initialInternalState[Sequences[sequenceKey]] = SequenceStates.INITIAL;
	});

	return initialInternalState;
})();

export default (state: SequencesStateType = initialState, action: SequencesActionType): Object => {
	switch (action.type) {
		case FLUSH_SEQUENCE as any:
			return { ...initialState };
		case START_SEQUENCE:
			return {
				...state,
				[action.sequenceName]: SequenceStates.RUNNING,
			};
		case FINISH_SEQUENCE:
			return {
				...state,
				[action.sequenceName]: SequenceStates.FINISHED,
			};
		default:
			return state;
	}
};
